import React from 'react';

const MobileNav = () => {
  return (
    <div className="mobile-nav__wrapper">
      <div
        className="mobile-nav__overlay mobile-nav__toggler"
        onClick={(e) => {
          e.preventDefault();
          const wrapper = document.querySelector('.mobile-nav__wrapper');
          if (wrapper) wrapper.classList.remove('expanded');
          document.body.classList.remove('locked');
        }}
      ></div>
      <div className="mobile-nav__content">
        <span
          className="mobile-nav__close mobile-nav__toggler"
          onClick={(e) => {
            e.preventDefault();
            const wrapper = document.querySelector('.mobile-nav__wrapper');
            if (wrapper) wrapper.classList.remove('expanded');
            document.body.classList.remove('locked');
          }}
        >
          <i className="fa fa-times"></i>
        </span>
        <div className="logo-box">
      
                <a href="/"><img src="assets/images/Rayyan Aid Logo-01.jpg" alt="Rayyan Aid logo" style={{ height: '100px', width: 'auto', verticalAlign: 'middle' }} /></a>
                <a href="/" className="main-menu__brand" style={{ marginLeft: '0px', display: 'inline-block', verticalAlign: 'middle', fontWeight: 800, fontSize: '24px', color: '#ffffff', textDecoration: 'none' }}>Rayyan Aid</a>
           
        </div>
        <div className="mobile-nav__container">{/* Filled by script.js; fallback below */}
          <ul className="main-menu__list">
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/donations">Donations</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
        <ul className="mobile-nav__contact list-unstyled">
          <li>
            <i className="fa fa-envelope"></i>
            <a href="mailto:info@rayyanaid.org">info@rayyanaid.org</a>
          </li>
          <li>
            <i className="fa fa-phone-alt"></i>
            <a href="tel:07063653772">07063653772</a>
          </li>
        </ul>
        <div className="mobile-nav__social">
          <a href="https://twitter.com/rayyanaid" target="_blank" rel="noopener noreferrer" aria-label="twitter"><i className="fab fa-twitter"></i></a>
          <a href="https://facebook.com/rayyanaid" target="_blank" rel="noopener noreferrer" aria-label="facebook"><i className="fab fa-facebook"></i></a>
          <a href="https://www.pinterest.com/rayyanaid" target="_blank" rel="noopener noreferrer" aria-label="pinterest"><i className="fab fa-pinterest-p"></i></a>
          <a href="https://instagram.com/rayyanaid" target="_blank" rel="noopener noreferrer" aria-label="instagram"><i className="fab fa-instagram"></i></a>
        </div>
      </div>
    </div>
  );
};

export default MobileNav;
